import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgEnvironmentTagOrange({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 50 20"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3 0h37.4a3 3 0 012.32 1.1l5.73 7a3 3 0 010 3.8l-5.73 7a3 3 0 01-2.33 1.1H3a3 3 0 01-3-3V3a3 3 0 013-3z"
        fill="#FB8F23"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgEnvironmentTagOrange.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgEnvironmentTagOrange.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgEnvironmentTagOrange svgRef={ref} {...props} />
));
export default ForwardRef;
